"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemFactory = void 0;
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Types_2 = require("ContentTokens/Models/inputs/Types");
var lodash_1 = __importDefault(require("lodash"));
var baseVariableItem = {
    type: Types_1.QuoteItemType.Variable,
    description: {
        content: "<p><br></p>",
        widgets: {},
    },
    quantity: 1,
    rate: {},
    discount: {
        enabled: false,
        type: Types_1.DiscountType.Percent,
        units: 0,
    },
    isTaxExempt: false,
    interactive: {
        isOptional: false,
        isOptionalSelected: false,
        isQuantityOptional: false,
        quantityRange: {
            min: 0,
            max: 10,
        },
    },
    billingSchedule: (0, Recurrence_1.createEmptyOneOffBillingSchedule)(),
};
var baseFixedCostItem = {
    type: Types_1.QuoteItemType.FixedCost,
    description: {
        content: "<p><br></p>",
        widgets: {},
    },
    quantity: 1,
    discount: {
        enabled: false,
        type: Types_1.DiscountType.Percent,
        units: 0,
    },
    rate: {
        unit: "Unit",
        rate: 0,
    },
    isTaxExempt: false,
    interactive: {
        isOptional: false,
        isOptionalSelected: false,
        isQuantityOptional: false,
        quantityRange: {
            min: 0,
            max: 10,
        },
    },
    billingSchedule: (0, Recurrence_1.createEmptyOneOffBillingSchedule)(),
};
var baseTextItem = {
    type: Types_1.QuoteItemType.Text,
    description: {
        content: "<p><br></p>",
        widgets: {},
    },
    interactive: {
        isOptional: false,
        isOptionalSelected: false,
    },
};
var baseProductItem = {
    type: Types_1.QuoteItemType.Product,
    description: {
        content: "<p><br></p>",
        widgets: {},
    },
    isTaxExempt: false,
    interactive: {
        isOptional: false,
        isOptionalSelected: false,
        isQuantityOptional: false,
        quantityRange: {
            min: 0,
            max: 10,
        },
    },
    token: new Types_2.RepeatingTokenInput("", "", ""),
    filter: undefined,
};
var additionalAllowedKeys = new Map([
    [Types_1.QuoteItemType.FixedCost, ["featureList", "integrations"]],
    [Types_1.QuoteItemType.Product, ["featureList"]],
]);
var ItemFactory = (function () {
    function ItemFactory() {
        this.templateQuoteItem = function (type, overrides) {
            var _a;
            if (overrides === void 0) { overrides = {}; }
            if (type !== Types_1.QuoteItemType.Text &&
                type !== Types_1.QuoteItemType.FixedCost &&
                type !== Types_1.QuoteItemType.Variable &&
                type !== Types_1.QuoteItemType.Product) {
                throw new Error("Got an unknown line item type: ".concat(type));
            }
            overrides = lodash_1.default.cloneDeep(overrides);
            delete overrides.currency;
            var item;
            switch (type) {
                case Types_1.QuoteItemType.Variable:
                    item = lodash_1.default.cloneDeep(baseVariableItem);
                    break;
                case Types_1.QuoteItemType.FixedCost:
                    item = lodash_1.default.cloneDeep(baseFixedCostItem);
                    break;
                case Types_1.QuoteItemType.Text:
                    item = lodash_1.default.cloneDeep(baseTextItem);
                    break;
                case Types_1.QuoteItemType.Product:
                    item = lodash_1.default.cloneDeep(baseProductItem);
                    break;
                default:
                    item = lodash_1.default.cloneDeep(baseTextItem);
            }
            var allowedKeys = lodash_1.default.keys(item).concat((_a = additionalAllowedKeys.get(type)) !== null && _a !== void 0 ? _a : []);
            return lodash_1.default.pick(lodash_1.default.merge(item, overrides), allowedKeys);
        };
    }
    return ItemFactory;
}());
exports.ItemFactory = ItemFactory;
